/**
 * Do not edit directly, this file was auto-generated.
 */

export const baseColorWhite = "#FFFFFF";
export const baseColorBlack = "#000000";
export const baseColorBlue1 = "#E8ECEE";
export const baseColorBlue2 = "#DCE8EF";
export const baseColorBlue3 = "#C6DDEC";
export const baseColorBlue4 = "#98C6E1";
export const baseColorBlue5 = "#6CB1DA";
export const baseColorBlue6 = "#49A0D4";
export const baseColorBlue7 = "#2C8EC9";
export const baseColorBlue8 = "#2477A8";
export const baseColorBlue9 = "#32769F";
export const baseColorBlue10 = "#25536F";
export const baseColorBlue11 = "#1C4259";
export const baseColorBlue12 = "#193C51";
export const baseColorBlue13 = "#142F3F";
export const baseColorBlue14 = "#0F2431";
export const baseColorBlue15 = "#0C1C25";
export const baseColorTeal100 = "#F5F8F9";
export const baseColorTeal200 = "#E7EEEF";
export const baseColorTeal300 = "#D7E5E7";
export const baseColorTeal400 = "#BBD3D6";
export const baseColorTeal500 = "#9BBFC4";
export const baseColorTeal600 = "#6095A1";
export const baseColorTeal700 = "#508592";
export const baseColorTeal800 = "#316C7F";
export const baseColorTeal900 = "#296072";
export const baseColorTeal1000 = "#1C4259";
export const baseColorRed1 = "#FDF6F8";
export const baseColorRed2 = "#FCEEF1";
export const baseColorRed3 = "#F8DDE3";
export const baseColorRed4 = "#F3C4CE";
export const baseColorRed5 = "#EDABB9";
export const baseColorRed6 = "#E78DA0";
export const baseColorRed7 = "#E05270";
export const baseColorRed8 = "#D9264C";
export const baseColorRed9 = "#BE1D3D";
export const baseColorRed10 = "#C41034";
export const baseColorRed11 = "#A50D2C";
export const baseColorRed12 = "#7B0A20";
export const baseColorRed13 = "#681122";
export const baseColorRed14 = "#4B0C19";
export const baseColorRed15 = "#2B080F";
export const baseColorGreen1 = "#F8FCF8";
export const baseColorGreen2 = "#ECF8EC";
export const baseColorGreen3 = "#DAF1DA";
export const baseColorGreen4 = "#C4E8C4";
export const baseColorGreen5 = "#A7DDA7";
export const baseColorGreen6 = "#91D491";
export const baseColorGreen7 = "#7BCC7B";
export const baseColorGreen8 = "#65C365";
export const baseColorGreen9 = "#51B851";
export const baseColorGreen10 = "#45A045";
export const baseColorGreen11 = "#3A863A";
export const baseColorGreen12 = "#347934";
export const baseColorGreen13 = "#2D672D";
export const baseColorGreen14 = "#255525";
export const baseColorGreen15 = "#1C401C";
export const baseColorGray1 = "#FFFFFF";
export const baseColorGray2 = "#F7F8F8";
export const baseColorGray3 = "#F1F3F4";
export const baseColorGray4 = "#E8ECEE";
export const baseColorGray5 = "#DBE2E5";
export const baseColorGray6 = "#CBD3D8";
export const baseColorGray7 = "#BFC9CF";
export const baseColorGray8 = "#ACBBC3";
export const baseColorGray9 = "#97A8B3";
export const baseColorGray10 = "#72828B";
export const baseColorGray11 = "#606B71";
export const baseColorGray12 = "#50595E";
export const baseColorGray13 = "#454B4F";
export const baseColorGray14 = "#333739";
export const baseColorGray15 = "#131415";
export const baseColorYellow1 = "#FDFAF5";
export const baseColorYellow2 = "#FCF4DF";
export const baseColorYellow3 = "#F9ECC7";
export const baseColorYellow4 = "#F8E7BA";
export const baseColorYellow5 = "#F4DDAF";
export const baseColorYellow6 = "#FBE2B6";
export const baseColorYellow7 = "#FAD59E";
export const baseColorYellow8 = "#FCC97E";
export const baseColorYellow9 = "#FBBF65";
export const baseColorYellow10 = "#FAB347";
export const baseColorYellow11 = "#F79D18";
export const baseColorYellow12 = "#DD8808";
export const baseColorYellow13 = "#BB7307";
export const baseColorYellow14 = "#8A5505";
export const baseColorYellow15 = "#593603";
export const baseColorGold1 = "#FDFAF5";
export const baseColorGold2 = "#FCF6EE";
export const baseColorGold3 = "#FAF3E5";
export const baseColorGold4 = "#F9ECD7";
export const baseColorGold5 = "#F6E2C1";
export const baseColorGold6 = "#F4DCB4";
export const baseColorGold7 = "#F1D4A4";
export const baseColorGold8 = "#E9CB9B";
export const baseColorGold9 = "#D4B786";
export const baseColorGold10 = "#C4A776";
export const baseColorGold11 = "#B19362";
export const baseColorGold12 = "#9C7F4D";
export const baseColorGold13 = "#8A6C3A";
export const baseColorGold14 = "#775926";
export const baseColorGold15 = "#60410E";
export const baseColorPurple1 = "#F7F2FD";
export const baseColorPurple2 = "#E3D8EF";
export const baseColorPurple3 = "#D6C7E6";
export const baseColorPurple4 = "#C8B5DC";
export const baseColorPurple5 = "#BAA3D2";
export const baseColorPurple6 = "#AC90C9";
export const baseColorPurple7 = "#9E7EBF";
export const baseColorPurple8 = "#906CB6";
export const baseColorPurple9 = "#825AAC";
export const baseColorPurple10 = "#7448A2";
export const baseColorPurple11 = "#663C91";
export const baseColorPurple12 = "#57317E";
export const baseColorPurple13 = "#48276B";
export const baseColorPurple14 = "#3A1D59";
export const baseColorPurple15 = "#270F40";
export const baseColorMcOrange1 = "#FFFCFC";
export const baseColorMcOrange2 = "#FEF7F4";
export const baseColorMcOrange3 = "#FFEFEA";
export const baseColorMcOrange4 = "#FDEAE7";
export const baseColorMcOrange5 = "#FDDAD2";
export const baseColorMcOrange6 = "#FCCDC0";
export const baseColorMcOrange7 = "#FAB5A2";
export const baseColorMcOrange8 = "#F7896F";
export const baseColorMcOrange9 = "#F05429";
export const baseColorMcOrange10 = "#E24F26";
export const baseColorMcOrange11 = "#C14421";
export const baseColorMcOrange12 = "#9D361D";
export const baseColorMcOrange13 = "#843016";
export const baseColorMcOrange14 = "#612212";
export const baseColorMcOrange15 = "#42170C";
export const baseColorMcBlue1 = "#FCFFFF";
export const baseColorMcBlue2 = "#F7FAFF";
export const baseColorMcBlue3 = "#EBF5FF";
export const baseColorMcBlue4 = "#E9F3FF";
export const baseColorMcBlue5 = "#D4EBFE";
export const baseColorMcBlue6 = "#C4E1FF";
export const baseColorMcBlue7 = "#AAD5FF";
export const baseColorMcBlue8 = "#77BFFF";
export const baseColorMcBlue9 = "#2EA1FF";
export const baseColorMcBlue10 = "#2799EF";
export const baseColorMcBlue11 = "#2681CD";
export const baseColorMcBlue12 = "#2067A5";
export const baseColorMcBlue13 = "#1D588B";
export const baseColorMcBlue14 = "#154166";
export const baseColorMcBlue15 = "#0F2C44";
export const baseBorderRadiusSm = "4";
export const baseBorderRadiusMd = "6";
export const baseBorderRadiusLg = "8";
export const baseBorderRadiusFull = "1000";
export const baseBorderWidthSm = "1";
export const baseBorderWidthMd = "2";
export const baseBorderWidthLg = "4";
export const baseFontWeightHeavy = "800";
export const baseFontWeightSemi = "700";
export const baseFontWeightMedium = "500";
export const baseFontWeightRegular = "400";
export const baseFontWeightLight = "300";
export const baseFontWeightBlackString = "BLK";
export const baseFontWeightBoldString = "BOLD";
export const baseFontWeightMediumString = "MD";
export const baseFontWeightRegularString = "REGULAR";
export const baseFontWeightOffwhiteString = "OFFWHITE";
export const baseFontWeightLightString = "LT";
export const baseFontSize1 = "14";
export const baseFontSize2 = "16";
export const baseFontSize3 = "18";
export const baseFontSize4 = "20";
export const baseFontSize5 = "22";
export const baseFontSize6 = "24";
export const baseFontSize7 = "28";
export const baseFontSize8 = "32";
export const baseFontSize9 = "36";
export const baseFontSize10 = "40";
export const baseFontSize11 = "44";
export const baseFontSize12 = "48";
export const baseFontSize13 = "54";
export const baseFontSize14 = "60";
export const baseFontSize15 = "68";
export const baseFontSize16 = "76";
export const baseFontSize17 = "84";
export const baseFontSize18 = "96";
export const baseFontSizeMini = "12";
export const baseFontFamilyPrimary = "BASIS GRT FOR THRIVENT";
export const baseFontFamilySecondary = "BURGESS FOR THRIVENT";
export const baseFontFamilyLofi = "COMIC NEUE";
export const baseFontFamilyLofiAlt = "REDACTED SCRIPT";
export const baseLineHeightXxxxs = "14";
export const baseLineHeightXxxs = "16";
export const baseLineHeightXxs = "18";
export const baseLineHeightXs = "20";
export const baseLineHeightS = "22";
export const baseLineHeightM = "24";
export const baseLineHeightL = "28";
export const baseLineHeightXl = "32";
export const baseLineHeightXxl = "40";
export const baseLineHeightXxxl = "44";
export const baseLineHeightXxxxl = "48";
export const baseLineHeightXxxxxl = "52";
export const baseLineHeightXxxxxxl = "56";
export const baseLineHeightXxxxxxxl = "72";
export const baseLineHeightBodyMini = "14";
export const baseLineHeightBodyDefault = "16";
export const baseSpacingXxxsm = "2";
export const baseSpacingXxsm = "4";
export const baseSpacingXsm = "8";
export const baseSpacingSm = "12";
export const baseSpacingMd = "16";
export const baseSpacingLg = "20";
export const baseSpacingXlg = "24";
export const baseSpacingXxlg = "32";
export const baseSpacingXxxlg = "40";
export const baseSpacingXxxxlg = "48";
export const baseSpacingXxxxxlg = "56";
export const baseSpacingXxxxxxlg = "64";
export const baseOpacityOverlay = "0.5";
export const baseRemXs01 = "0.125";
export const baseRemXs02 = "0.25";
export const baseRemXs03 = "0.375";
export const baseRemXs04 = "0.42500001192092896";
export const baseRemS01 = "0.5";
export const baseRemS02 = "0.625";
export const baseRemS03 = "0.75";
export const baseRemS04 = "0.875";
export const baseRemM01 = "1";
export const baseRemM02 = "1.125";
export const baseRemM03 = "1.25";
export const baseRemM04 = "1.375";
export const baseRemL01 = "1.5";
export const baseRemL02 = "1.75";
export const baseRemL03 = "2";
export const baseRemL04 = "2.25";
export const baseRemXl01 = "2.625";
export const baseRemXl02 = "3";
export const baseRemXl03 = "3.375";
export const baseRemXl04 = "3.75";
export const baseRemXxl01 = "4.25";
export const baseRemXxl02 = "4.75";
export const baseRemXxl03 = "5.25";
export const baseRemXxl04 = "6";
export const baseBaseSize = "16";
export const baseLetterSpacing1 = "1";
export const baseLetterSpacing2 = "2";
export const semanticColorShadowWeak = "#CBD3D8";
export const semanticColorShadowMedium = "#ACBBC3";
export const semanticColorShadowStrong = "#72828B";
export const semanticColorIdentityBrandPrimaryFaint = "#DCE8EF";
export const semanticColorIdentityBrandPrimaryWeak = "#6CB1DA";
export const semanticColorIdentityBrandPrimaryMedium = "#32769F";
export const semanticColorIdentityBrandPrimaryStrong = "#1C4259";
export const semanticColorIdentityBrandPrimaryHeavy = "#142F3F";
export const semanticColorIdentityBrandPrimaryDense = "#0C1C25";
export const semanticColorIdentityBrandSecondary = "#E9CB9B";
export const semanticColorIdentityMdsPrimary100 = "#E8ECEE";
export const semanticColorIdentityMdsPrimary300 = "#C6DDEC";
export const semanticColorIdentityMdsPrimary500 = "#6CB1DA";
export const semanticColorIdentityMdsPrimary700 = "#2C8EC9";
export const semanticColorIdentityMdsPrimary900 = "#32769F";
export const semanticColorIdentityMdsPrimary1100 = "#1C4259";
export const semanticColorIdentityMdsPrimary1200 = "#193C51";
export const semanticColorIdentityMdsPrimary1300 = "#142F3F";
export const semanticColorIdentityMdsPrimary1500 = "#0C1C25";
export const semanticColorIdentityMdsSecondary100 = "#FDFAF5";
export const semanticColorIdentityMdsSecondary300 = "#FAF3E5";
export const semanticColorIdentityMdsSecondary500 = "#F6E2C1";
export const semanticColorIdentityMdsSecondary700 = "#F1D4A4";
export const semanticColorIdentityMdsSecondary900 = "#D4B786";
export const semanticColorIdentityMdsSecondary1100 = "#B19362";
export const semanticColorIdentityMdsTertiary100 = "#F5F8F9";
export const semanticColorIdentityMdsTertiary200 = "#E7EEEF";
export const semanticColorIdentityMdsTertiary300 = "#D7E5E7";
export const semanticColorIdentityMdsTertiary500 = "#9BBFC4";
export const semanticColorIdentityMdsTertiary600 = "#6095A1";
export const semanticColorIdentityMdsTertiary700 = "#508592";
export const semanticColorIdentityMdsTertiary800 = "#316C7F";
export const semanticColorIdentityMdsExpressive100 = "#FDF6F8";
export const semanticColorIdentityMdsExpressive300 = "#F8DDE3";
export const semanticColorIdentityMdsExpressive500 = "#EDABB9";
export const semanticColorIdentityMdsExpressive700 = "#E05270";
export const semanticColorIdentityMdsExpressive800 = "#D9264C";
export const semanticColorIdentityMdsExpressive900 = "#BE1D3D";
export const semanticColorIdentityMdsExpressive1100 = "#A50D2C";
export const semanticColorIdentityMdsExpressive1200 = "#7B0A20";
export const semanticColorIdentityBrandTertiary = "#BE1D3D";
export const semanticColorIdentityBrandTertiaryStrong = "#A50D2C";
export const semanticColorIdentityBrandTertiaryHeavy = "#681122";
export const semanticColorIdentityMdsNeutral100 = "#FFFFFF";
export const semanticColorIdentityMdsNeutral400 = "#E8ECEE";
export const semanticColorIdentityMdsNeutral800 = "#ACBBC3";
export const semanticColorIdentityMdsNeutral900 = "#97A8B3";
export const semanticColorTextPrimary = "#131415";
export const semanticColorTextSecondary = "#333739";
export const semanticColorTextTertiary = "#50595E";
export const semanticColorTextDisabled = "#ACBBC3";
export const semanticColorTextLink = "#32769F";
export const semanticColorTextPrimaryDarkBg = "#FFFFFF";
export const semanticColorTextSecondaryDarkBg = "#F1F3F4";
export const semanticColorTextTertiaryDarkBg = "#DBE2E5";
export const semanticColorTextLinkDarkBg = "#C6DDEC";
export const semanticColorTextInvalid = "#A50D2C";
export const semanticColorTextNeutralHigh = "#131415";
export const semanticColorTextNeutralMedium = "#454B4F";
export const semanticColorTextNeutralLow = "#606B71";
export const semanticColorTextExpressiveMedium = "#BE1D3D";
export const semanticColorTextInverseHigh = "#FFFFFF";
export const semanticColorTextInverseMedium = "#F1F3F4";
export const semanticColorTextInverseLow = "#DBE2E5";
export const semanticColorBackgroundPrimary = "#FFFFFF";
export const semanticColorBackgroundSecondary = "#FCF6EE";
export const semanticColorBackgroundDisabled = "#F7F8F8";
export const semanticColorBackgroundNeutralDefault = "#FFFFFF";
export const semanticColorBackgroundNeutralHover = "#F1F3F4";
export const semanticColorBackgroundNeutralPressed = "#DBE2E5";
export const semanticColorBackgroundNeutralInactive = "#E8ECEE";
export const semanticColorBorderDefault = "#CBD3D8";
export const semanticColorBorderDisabled = "#E8ECEE";
export const semanticColorBorderFocus = "#2477A8";
export const semanticColorBorderFocusDarkbg = "#FBBF65";
export const semanticColorBorderHover = "#50595E";
export const semanticColorBorderInvalid = "#A50D2C";
export const semanticColorSentimentNegativeFaint = "#F8DDE3";
export const semanticColorSentimentNegativeWeak = "#E78DA0";
export const semanticColorSentimentNegativeMedium = "#BE1D3D";
export const semanticColorSentimentNegativeStrong = "#A50D2C";
export const semanticColorSentimentNegativeHeavy = "#681122";
export const semanticColorSentimentNegativeDense = "#2B080F";
export const semanticColorSentimentPositiveFaint = "#DAF1DA";
export const semanticColorSentimentPositiveWeak = "#91D491";
export const semanticColorSentimentPositiveMedium = "#51B851";
export const semanticColorSentimentPositiveStrong = "#3A863A";
export const semanticColorSentimentPositiveHeavy = "#2D672D";
export const semanticColorSentimentPositiveDense = "#1C401C";
export const semanticColorSentimentWarningFaint = "#FCF4DF";
export const semanticColorSentimentWarningWeak = "#F4DDAF";
export const semanticColorSentimentWarningMedium = "#FCC97E";
export const semanticColorSentimentWarningStrong = "#FAB347";
export const semanticColorSentimentWarningHeavy = "#DD8808";
export const semanticColorSentimentWarningDense = "#593603";
export const semanticColorSentimentInfoFaint = "#DCE8EF";
export const semanticColorSentimentInfoWeak = "#49A0D4";
export const semanticColorSentimentInfoMedium = "#32769F";
export const semanticColorSentimentInfoStrong = "#1C4259";
export const semanticColorSentimentInfoHeavy = "#142F3F";
export const semanticColorSentimentInfoDense = "#0C1C25";
export const semanticColorNeutralLightWeak = "#FFFFFF";
export const semanticColorNeutralLightMedium = "#F7F8F8";
export const semanticColorNeutralLightStrong = "#DBE2E5";
export const semanticColorNeutralLightHeavy = "#BFC9CF";
export const semanticColorNeutralDarkWeak = "#97A8B3";
export const semanticColorNeutralDarkMedium = "#50595E";
export const semanticColorNeutralDarkStrong = "#333739";
export const semanticColorNeutralDarkHeavy = "#131415";
export const semanticColorDisabledOpacity = "30";
export const componentChipRadiusDefault = "4";
export const componentChipRadiusFocus = "6";
export const componentChipColorBackgroundSelectedDefault = "#32769F";
export const componentChipColorBackgroundSelectedHover = "#193C51";
export const componentChipColorBackgroundUnselectedDefault = "#FFFFFF";
export const componentChipColorBackgroundUnselectedHover = "#DCE8EF";
export const componentChipColorBorderUnselected = "#142F3F";
export const componentChipColorTextSelected = "#FFFFFF";
export const componentChipColorTextUnselected = "#142F3F";
export const componentChipColorIconSelected = "#FFFFFF";
export const componentChipColorIconUnselected = "#142F3F";
export const componentChipPaddingSm = "2";
export const componentChipPaddingMd = "4";
export const componentChipPaddingLg = "8";
export const componentButtonRadiusDefault = "6";
export const componentButtonColorBackgroundStrongPrimaryDefault = "#1C4259";
export const componentButtonColorBackgroundStrongPrimaryHover = "#32769F";
export const componentButtonColorBackgroundStrongPrimaryPressed = "#2477A8";
export const componentButtonColorBackgroundStrongSecondaryDefault = "#32769F";
export const componentButtonColorBackgroundStrongSecondaryHover = "#25536F";
export const componentButtonColorBackgroundStrongSecondaryPressed = "#1C4259";
export const componentButtonColorBackgroundStrongDestructiveDefault = "#A50D2C";
export const componentButtonColorBackgroundStrongDestructiveHover = "#BE1D3D";
export const componentButtonColorBackgroundStrongDestructivePressed = "#681122";
export const componentButtonColorBackgroundSubtleDefault = "#FFFFFF";
export const componentButtonColorBackgroundSubtlePrimaryHover = "#E8ECEE";
export const componentButtonColorBackgroundSubtlePrimaryPressed = "#C6DDEC";
export const componentButtonColorBackgroundSubtleSecondaryHover = "#F9ECD7";
export const componentButtonColorBackgroundSubtleSecondaryPressed = "#F1D4A4";
export const componentButtonColorBackgroundSubtleDestructiveHover = "#FCEEF1";
export const componentButtonColorBackgroundSubtleDestructivePressed = "#F3C4CE";
export const componentButtonColorBorderSecondaryDefault = "#316C7F";
export const componentButtonColorBorderSubtlePrimaryDefault = "#25536F";
export const componentButtonColorBorderSubtlePrimaryHover = "#193C51";
export const componentButtonColorBorderSubtlePrimaryPressed = "#0C1C25";
export const componentButtonColorBorderSubtleSecondaryDefault = "#25536F";
export const componentButtonColorBorderSubtleSecondaryHover = "#193C51";
export const componentButtonColorBorderSubtleSecondaryPressed = "#0C1C25";
export const componentButtonColorBorderSubtleDestructiveDefault = "#D9264C";
export const componentButtonColorBorderSubtleDestructiveHover = "#BE1D3D";
export const componentButtonColorBorderSubtleDestructivePressed = "#C41034";
export const componentButtonColorTextStrongPrimary = "#FFFFFF";
export const componentButtonColorTextStrongSecondary = "#FFFFFF";
export const componentButtonColorTextStrongDestructive = "#FFFFFF";
export const componentButtonColorTextSubtlePrimary = "#0C1C25";
export const componentButtonColorTextSubtleSecondary = "#1C4259";
export const componentButtonColorTextSubtleDestructive = "#A50D2C";
export const componentButtonColorTextGhostPrimary = "#142F3F";
export const componentButtonColorTextGhostDestructive = "#A50D2C";
export const componentButtonPaddingDefault = "16";
export const componentContainerBorderWidthDefault = "1";
export const componentContainerBorderWidthEmphasis = "2";
export const componentContainerBorderWidthFocus = "4";
export const componentContainerColorBackgroundDefault = "#FFFFFF";
export const componentContainerColorBackgroundHover = "#DCE8EF";
export const componentContainerColorBackgroundInfoEmphasis = "#32769F";
export const componentContainerColorBackgroundInfoSubtle = "#DCE8EF";
export const componentContainerColorBackgroundPositiveEmphasis = "#3A863A";
export const componentContainerColorBackgroundPositiveSubtle = "#DAF1DA";
export const componentContainerColorBackgroundNegativeEmphasis = "#A50D2C";
export const componentContainerColorBackgroundNegativeSubtle = "#F8DDE3";
export const componentContainerColorBackgroundWarningEmphasis = "#FCC97E";
export const componentContainerColorBackgroundWarningSubtle = "#FCF4DF";
export const componentContainerColorTextHeadingSubtle = "#131415";
export const componentContainerColorTextHeadingInfoEmphasis = "#FFFFFF";
export const componentContainerColorTextHeadingNegativeEmphasis = "#FFFFFF";
export const componentContainerColorTextHeadingPositiveEmphasis = "#FFFFFF";
export const componentContainerColorTextHeadingWarningEmphasis = "#131415";
export const componentContainerColorTextParagraphSubtle = "#131415";
export const componentContainerColorTextParagraphInfoEmphasis = "#FFFFFF";
export const componentContainerColorTextParagraphNegativeEmphasis = "#FFFFFF";
export const componentContainerColorTextParagraphPositiveEmphasis = "#F1F3F4";
export const componentContainerColorTextParagraphWarningEmphasis = "#131415";
export const componentContainerColorBorderDefault = "#CBD3D8";
export const componentContainerColorBorderInfo = "#1C4259";
export const componentContainerColorBorderPositive = "#2D672D";
export const componentContainerColorBorderNegative = "#A50D2C";
export const componentContainerColorBorderWarning = "#DD8808";
export const componentContainerOpacityOverlay = "0.5";
export const componentContainerPaddingSm = "8";
export const componentContainerPaddingMd = "16";
export const componentContainerPaddingLg = "24";
export const componentContainerRadiusDefault = "6";
export const componentFormRadiusDefault = "4";
export const componentFormColorTextLabelDefault = "#606B71";
export const componentFormColorTextLabelHover = "#50595E";
export const componentFormColorTextLabelActive = "#32769F";
export const componentFormColorTextInvalid = "#A50D2C";
export const componentFormColorTextDisabled = "#ACBBC3";
export const componentFormColorTextPlaceholder = "#606B71";
export const componentFormColorTextInput = "#131415";
export const componentFormColorBackgroundDefault = "#FFFFFF";
export const componentFormColorBackgroundDisabled = "#F7F8F8";
export const componentFormColorBackgroundReadonly = "#F7F8F8";
export const componentFormColorBorderDefault = "#606B71";
export const componentFormColorBorderDisabled = "#E8ECEE";
export const componentFormColorBorderFocus = "#2477A8";
export const componentFormColorBorderActive = "#32769F";
export const componentFormColorBorderHover = "#000000";
export const componentFormColorBorderInvalid = "#A50D2C";
export const componentLinkDefault = "#32769F";
export const componentLinkHover = "#1C4259";
export const componentLinkVisited = "#663C91";
export const componentTableBackgroundDefault = "#FFFFFF";
export const componentTableBackgroundHover = "#DCE8EF";
export const componentTableBackgroundChecked = "#DCE8EF";
export const componentTableBackgroundCheckedHover = "#98C6E1";
export const componentTableBackgroundDefault2 = "#FFFFFF";
export const componentTableBackgroundHover2 = "#F7F8F8";
export const componentTableBackgroundChecked2 = "#F7F8F8";
export const componentTableBackgroundCheckedHover2 = "#E8ECEE";
